module.exports = {
	CubeTexture: require("./CubeTexture").default,
	RectangleTexture: require("./RectangleTexture").default,
	Texture: require("./Texture").default,
	TextureBase: require("./TextureBase").default,
	VideoTexture: require("./VideoTexture").default,
}